<template>
    <div class="tags" :class="{nowrap: isSimple}">
        <cl-tag 
            v-for="(item,k) in list" 
            :key="k+'tag'" 
            :item="item" 
            :disabled="disabled"
            :solidColorBag="solidColorBag"
            :class="{mb12: isAll}" 
            @delete="deleteFn(item)"
            :height="height"
        >
        </cl-tag>
        <div class="more" v-show="isSimple">
            <el-popover
                v-if="isPopover"
                placement="bottom-end"
                width="330"
                trigger="hover"
                popper-class="tag_group_el_popover"
            >
                <cl-tag
                    v-for="(item, k) in list"
                    class="mb10"
                    :key="k+'tag'"
                    :item="item"
                    :disabled="disabled"
                    @delete="deleteFn"
                    height="25px"
                />
                <div slot="reference">
                    <div
                        class="more el-icon-more"
                        v-show="isSimple"
                        :style="{
                            width: moreWidth,
                            height: moreHeight,
                            background: `url(${moreBagImg}), linear-gradient(270deg, ${moreBag} 60%, ${$utils.hexToRgb(moreBag, 0)} 100%)`,
                            color: moreColor
                        }"
                    ></div>
                </div>
            </el-popover>
        </div>
        
    </div>
</template>

<script>
    /**
     * ComponentName: 标签平铺显示
     * Created Date:2022/5/6
     * Author: Nancy
     * Modify: shishuo·zhang 2022/6/2
     * 组件说明：
     * view: all全部视图，simple简单视图
     * disabled: 默认是只能看true，false代表可以删除
     * eg:
     *     <cl-tag-group :list="list"></cl-tag-group>
     */
    export default {
        name: 'cl-tag-group',
        data() {
            return {

            };
        },
        props: {
            list: {
                type: Array,
                default: () => []
            },
            view: {
                type: String,
                default: 'all'
            },
            disabled: {
                type: Boolean,
                default: true
            },
            // 是否显示弹窗
            isPopover:{
                type: Boolean,
                default: true,
            },
            height: {
                type: String,
                default: '21px'
            },
            // 更多按钮宽度
            moreWidth: {
                type: String,
                default: '72px'
            },
            // 更多按钮高度
            moreHeight: {
                type: String,
                default: '27px'
            },
            // 更多按钮渐变背景色
            moreBag: {
                type: String,
                default: '#ffffff'
            },
            moreBagImg: {
                type: String,
                default: ''
            },
            // 更多按钮颜色
            moreColor: {
                type: String,
                default: '#B7B7BF'
            },
            // 标签是否实心背景
            solidColorBag: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            // 删除标签
            deleteFn(item) {
                this.$emit('delete', item);
            }
        },

        computed: {
            // 是否是简洁模式
            isSimple() {
                return this.view === 'simple'
            },
            // 是否是全部模式
            isAll() {
                return this.view === 'all';
            }
        },
    }
</script>
<style lang='scss' scoped>
    .nowrap {
        white-space: nowrap;
    }

    .tags {
        width: 100%;
        overflow: hidden;
        position: relative;

        .more {
            display: inline-block;
            position: absolute;
            top: 0;
            right: 0;
            // background: linear-gradient(270deg, #2051DC 60%, rgba(32, 81, 220, 0) 100%);    
            // background: linear-gradient(270deg, #FFFFFF 60%, rgba(255, 255, 255, 0) 100%);
            display: flex;
            align-items: center;
            justify-content: flex-end;
            // color: #B7B7BF;
            font-size: 16px;
        }
    }
</style>
<style lang="scss">
.tag_group_el_popover{
    box-shadow: 4px 4px 10px rgba(18, 29, 126, 0.05), 6px 6px 30px rgba(18, 29, 126, 0.1);
    border-radius: 10px;
    padding: 24px;
    line-height: 1;
    margin-top: 25px !important;
    box-sizing: border-box;
}
</style>